"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const crud_client_1 = require("./crud.client");
class SegmentClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'segments';
    }
    getUpdatePayloadModel(segment, method) {
        if (segment.temporary && method === models_1.RequestMethod.Put) {
            throw new Error('Temporary segment does not support update');
        }
        const model = Object.assign(Object.assign(Object.assign({}, segment), (method === models_1.RequestMethod.Put && { updaterId: segment.updaterId, temporary: undefined })), (method === models_1.RequestMethod.Post && { creatorId: segment.creatorId }));
        return new SegmentSaveRequestModel(model);
    }
    getBookmarkedSegments(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/bookmarked`);
            return response.payload;
        });
    }
    getTraffic(projectId, input, from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            let url;
            const query = {
                from: from.toISOString(),
                to: to.toISOString(),
            };
            if (typeof input === 'string') {
                query.fovCondition = input;
                url = `/v1/projects/${projectId}/segments/traffic`;
            }
            else {
                url = `/v1/projects/${projectId}/segments/${input}/traffic`;
            }
            const response = yield this.httpGet(`${url}?${this.getQueryString(query)}`);
            return response.payload;
        });
    }
    getSegmentStats(projectId, segmentIds, from, to, toCurrency) {
        return __awaiter(this, void 0, void 0, function* () {
            let url;
            if (segmentIds instanceof Array) {
                url = `/v1/projects/${projectId}/segments/stats?from=${from.toISOString()}&to=${to.toISOString()}&segmentIds=${segmentIds.join(',')}`;
            }
            else {
                url = `/v1/projects/${projectId}/segments/${segmentIds}/stats?from=${from.toISOString()}&to=${to.toISOString()}`;
            }
            if (toCurrency) {
                url = url + `&toCurrency=${toCurrency}`;
            }
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSegmentConditions(projectId, withUserAgents = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/conditions?withUserAgents=${withUserAgents}`);
            return response.payload;
        });
    }
    getSegmentsByGoalIdFOV(projectId, goalId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/by-goal?goalId=${goalId}`);
            return response.payload;
        });
    }
    getDeviceModels(projectId, manufacturer) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/device-models?manufacturer=${manufacturer}`);
            return response.payload;
        });
    }
    getFovDetails(projectId, fov) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/segments/fov-details`, fov);
            return response.payload;
        });
    }
    getSegmentDependencies(projectId, ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/dependencies?ids=${ids.join(',')}`);
            return response.payload;
        });
    }
    getPageEvents(projectId, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/page-events`, request);
            return response.payload;
        });
    }
}
exports.SegmentClient = SegmentClient;
class SegmentSaveRequestModel {
    constructor(segment) {
        this.name = segment.name;
        this.category = segment.category;
        this.fovCondition = segment.fovCondition;
        this.updaterId = segment.updaterId;
        this.creatorId = segment.creatorId;
        this.temporary = segment.temporary;
    }
}
//# sourceMappingURL=segment.client.js.map